import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createReservation = (data) => api.post("/reservations", data).then((r) => r.data);
export const createApplication = (data) => api.post("/applications", data).then((r) => r.data);
export const createContact = (data) => api.post("/contact", data).then((r) => r.data);
